import type { BranchMiniEntity } from '@/features/branch/domain/entities/BranchMiniEntity'

export class DeliveryDiscountBranchesFilterEntity {
  id!: string
  branch?: BranchMiniEntity
  page?: number
  limit?: number
}
